import { BallotType } from "../enums/ballot-type-enum";
import { UnifiedBallotStatus } from "../enums/unified-ballot-status-enum";
import { IBallotTypeEnumValue, IConnectEnumValue } from "../models/connect-enum";

export class ConnectEnumUtility {

  // T extends Typescript definition of enum
  public static getStatusDisplayTextById<T extends { [K in keyof T]: string | number }>(
    enumInstance: IConnectEnumValue<T>[], 
    enumId: T | undefined
  ): string | undefined {

    let displayName: string | undefined = undefined;
    
    if (enumId !== undefined && enumInstance) {
      enumInstance.forEach((enumValue: IConnectEnumValue<T>) => {
        if (enumValue.id === enumId) {
            displayName = enumValue.displayText;
        }
      });
    }
    return displayName;
  }

  public static getUnifiedBallotStatusMapping(
    ballotTypeEnumInstance: IBallotTypeEnumValue[],
    enumId: BallotType | undefined
  ) : UnifiedBallotStatus[] | undefined {
    if (enumId === undefined || ballotTypeEnumInstance === undefined) {
      return undefined;
    }

    let unifiedBallotStatusMapping: UnifiedBallotStatus[] = [];
    ballotTypeEnumInstance.forEach((ballotTypeEnumValue: IBallotTypeEnumValue) => {
      if (ballotTypeEnumValue.id === enumId) {
        unifiedBallotStatusMapping = ballotTypeEnumValue.unifiedBallotStatusMapping;
      }
    });
    return unifiedBallotStatusMapping;
  }
}
